<template>
  <div>
    <!-- 
      type: {
        name:enter,
        name:number,
        name:select,
        name:multi,
        name:data,
        name:mapped,
        name:area
        name 11: 'multiTree',
      }
     -->
    <!-- 输入控件 -->
    <tag-input v-if="type==='enter'" v-model="value" ref="tagInput" class="tagInput" @change="change" :placeholder="placeholderId" />

    <!-- 数值范围控件   :flagValidate="error.length>0"-->
    <input-range ref='conditionVal' v-if="type=='number'" :max="max" :value="value" @change="change" :unit="unit" :prefix="prefix" :constraint="constraint" :chosedConditionName="chosedConditionName"
      :error="error" @input-cv-focus='inputFocus' @validateNode="validateNode" />
    <!-- 单选控件 -->
    <el-select v-if="type==='select'" style="width:160px;" v-model="selectValue" size="small" placeholder="请选择条件" @change="change" @blur="blur" @focus="focus">
      <el-option v-for="(item,i) in options" :key="i" :label="item.label" :value="item.value" />
    </el-select>

    <!-- 多选控件 -->
    <multi-select v-if="type=='multi'" ref='conditionVal' :value="value" :glId="glId" :placeholder="placeholder" :error="error" :options="options" @change="change" @validateNode="validateNode"
      @input-cv-focus='inputFocus' />

    <!-- 日期范围控件 -->
    <date-range v-if="type=='data'" ref='conditionVal' :value="value" :error="error" :dateName="dateName" @change="change" @validateNode="validateNode" @input-cv-focus='inputFocus'
      :constraint="constraint" />

    <!-- 地区控件 selected = value-->
    <!-- <area-search-select ref='conditionVal' v-if="type=='area'" :selected='value' :placeholder='placeholder' :options="options" @changeArea='change' :error="error"
      @input-cv-focus='inputFocus' @validateNode="validateNode"></area-search-select> -->
    <!-- 新的 地区&行业 -->
    <TreeDropdown v-if="type=='multiTree'" ref='conditionVal' :value="value" placeholder="请选择条件" multiple filterable showCheckbox nodeKey="value" :data="options" :defaultProps="{ children: 'childOption'}"
      @input="treeDropdownInput" @change="change" />

    <!-- 二三级公共控件 :levelConfig='options'-->
    <menu-common ref='conditionVal' v-if="type=='mapped'" :defaultValue="value ? value :[]" :placeholder='placeholder' :options='options' :type='type' :error="error" @input-cv-focus='inputFocus'
      @validateNode="validateNode" @change='change' />

  </div>
</template>

<script>
import TreeDropdown from '@/components/treeDropdown/treeDropdown'
import AreaSearchSelect from "./children/AreaSearchSelect.vue";
import inputRange from "./children/inputRange";
import dataPicker from "./children/dataPicker";
import isNil from "lodash/isNil";
import isArray from "lodash/isArray";
import Clickoutside from '@/utils/clickoutside'
import inputItem from "./children/inputItem";
import multiSelect from "./children/multiSelect";
import dateRange from "./children/dateRange";
import singleSelect from "./children/singleSelect";
import SingleSelect from "./children/singleSelect.vue";
// import MenuCommon from "@/views/clue/advancecomponets/children/MenuCommon.vue";
import tagInput from "./children/tagInput.vue";


import mixin from './stopon.js'
export default {
  mixins: [mixin],
  name: "inputRender",
  props: [
    "type",
    "placeholder",
    "value",
    "options",
    "error",
    "constraint",
    "totalWidth",
    "crExit",
    "unit",
    "prefix",
    "cr",
    "exitCrOptions",
    "chosedConditionName",
    "dateName",
    'levelConfig',
    'inputOptions',//
    'glId',
    'num'
  ],
  components: {
    inputRange,
    dataPicker,
    AreaSearchSelect,
    inputItem,
    multiSelect,
    dateRange,
    singleSelect,
    SingleSelect,
    // MenuCommon,
    MenuCommon: () => import('@/views/clue/advancecomponets/children/MenuCommon.vue'),
    TreeDropdown,
    tagInput
  },
  directives: { Clickoutside },
  data() {
    return {
      selectValue: '1',
      placeholderId: '',
      max: 999999999
    }
  },
  mounted() {
    if (this.type === 'select') {
      this.value && (this.selectValue = this.value[0].value || this.value[0])
    }
    // 法院公告关联案号默认提示
    if (this.glId == 193) {
      this.placeholderId = '输入法院公告关联案号'
    } else {
      this.placeholderId = '单个词不超过30个字符;最多20个词;回车键隔开'
    }
    if (this.num == 10) {
      this.max = 100
    }

  },
  methods: {
    treeDropdownInput(value) {
      this.$emit("input", value)
    },
    change(value) {
      this.$emit("change", value)
    },

    // 失焦/聚焦/报错样式统一
    inputFocus(isFocus) {
      this.$emit("inputFocus", isFocus)
    },
    inputBlur(isBlur = false) {
      this.inputFocus(false)
    },

    transferValidate() {
      return this.$refs.conditionVal.validator()
    },

    validateNode() {
      this.$emit("validateNode")
    }
  }
};
</script>

<style lang="scss" scoped>
.tagInput {
  width: 300px;
}
// .el-select--mini,
// .el-input--mini {
//   width: 360px;
// }
// .input-cn {
//   width: 250px;
//   .el-icon-error {
//     font-size: 12px;
//   }
//   > span {
//     display: inline-block;
//     width: 100%;
//   }
//   // &.signle-input-cn,
//   // &.number-input-cn {
//   //   width: auto;
//   // }
// }
// .custom-multi {
//   position: relative;
//   .clear-icon {
//     position: absolute;
//     top: 50%;
//     transform: translateY(-50%);
//     right: 11px;
//     color: #d9d9d9;
//     z-index: 1000;
//   }
//   .el-tag {
//     border-radius: 2px;
//   }
//   .el-range-editor.is-active,
//   .el-range-editor.is-active:hover {
//     box-shadow: 0px 0px 8px 0px rgba(255, 144, 82, 0.4);
//   }
// }
// .custom-option-box {
//   border: none;
//   .el-select-dropdown__empty {
//     display: none;
//   }
//   .popper__arrow {
//     display: none;
//   }
// }
// // .input-cn {
// //   .el-tag__close {
// //     border-radius: 0;
// //     color: #999 !important;
// //     background-color: #f2f2f2 !important;
// //     font-size: 16px !important;
// //   }
// //   .el-tag {
// //     background-color: #f2f2f2;
// //     color: #595959 !important;
// //     border-radius: 2px;
// //   }

// //   .multi-selec {
// //     width: 200px;
// //   }
// // }
// .el-select__tags {
//   white-space: normal;
//   overflow: visible;
// }
// .multi-select {
//   .el-input__inner {
//     border-radius: 0 2px 2px 0;
//   }
// }

// .custom-flex {
//   .el-select .el-input {
//     .el-select__caret {
//       color: #d8d8d8;
//       &.el-input__icon {
//         &.el-icon-arrow-up:before {
//           // content: "\e78f";
//         }
//       }
//     }
//   }
// }
// // 自定义组件样式
// .custom-multi,
// .input-cn {
//   .el-select {
//     width: 100%;
//   }
//   // 日期/输入框/多选等
//   .el-input__inner {
//     border: none;
//     color: #595959;
//     height: 26px;
//     &:focus {
//       border: none !important;
//     }
//   }
//   .el-date-editor--daterange.el-input__inner {
//     width: 250px;
//   }
//   // 聚焦
//   .el-input.is-focus .el-input__inner {
//     border: none !important;
//   }
// }
// .single-select {
//   display: inline-block;
//   position: relative;
//   width: 82px;
//   .el-select {
//     width: 82px !important;
//   }
//   .el-icon-arrow-up {
//     display: none;
//   }
//   .el-icon-caret-bottom {
//     right: 8px;
//     position: absolute;
//     font-size: 14px;
//     top: 50%;
//     color: #d9d9d9;
//     transform: translateY(-50%);
//   }
//   .el-input__inner {
//     font-size: 12px;
//     padding-left: 8px;
//   }
//   .popper__arrow {
//     display: none;
//   }
//   .el-popper {
//     //  top: 30px !important;
//     left: 0px !important;
//     margin-top: 4px !important;
//   }
// }
// .multi-select-box {
//   display: inline-block;
//   position: relative;
//   //   width: 100%;
//   // //   .el-icon-caret-bottom {
//   // //     right: 8px;
//   // //     position: absolute;
//   // //     font-size: 14px;
//   // //     top: 50%;
//   // //     color: #d9d9d9;
//   // //     transform: translateY(-50%);
//   // //   }
//   .el-icon-arrow-up {
//     display: none;
//   }
//   .popper__arrow {
//     display: none;
//   }
//   .el-popper {
//     top: 30px !important;
//     left: 0px !important;
//     margin-top: 0px !important;
//   }
//   .el-input__inner {
//     // border-top-left-radius: 0;
//     // border-bottom-left-radius: 0;
//     border: none;
//   }
// }
// .multi-option {
//   .popper__arrow {
//     display: none;
//   }
// }
// .multi-select-box {
//   .el-input__inner {
//     font-size: 12px;
//     padding: 0 8px;
//   }
// }
</style>
